import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { t as tryParse } from './index-39f51a91.js';
import { B as Brand } from './types-66e6568b.js';
import './currency-49e0d692.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';

const sePesComparisonPdfCss = ":host{display:block}";

const ApcPesComparisonPdf = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this._comparatorLabels = undefined;
    this._comparatorCharacteristics = undefined;
    this._comparatorPriceInfo = undefined;
    this.comparatorLabels = undefined;
    this.comparatorCharacteristics = undefined;
    this.comparatorPriceInfo = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.comparatorLabels = (_a = tryParse(this._comparatorLabels)) !== null && _a !== void 0 ? _a : this.comparatorLabels;
    this.comparatorCharacteristics = (_b = tryParse(this._comparatorCharacteristics)) !== null && _b !== void 0 ? _b : this.comparatorCharacteristics;
    this.comparatorPriceInfo = (_c = tryParse(this._comparatorPriceInfo)) !== null && _c !== void 0 ? _c : this.comparatorPriceInfo;
  }
  render() {
    return (h(Host, null, h("pes-comparison-pdf", { comparatorLabels: this.comparatorLabels, comparatorCharacteristics: this.comparatorCharacteristics, comparatorPriceInfo: this.comparatorPriceInfo, brand: Brand.se })));
  }
};
ApcPesComparisonPdf.style = sePesComparisonPdfCss;

export { ApcPesComparisonPdf as se_pes_comparison_pdf };
